import ContentsUI from './components/ContentsUI';

const Contents = () => {
  return (
    <ContentsUI />
  );
}

export default Contents;
